import { memo } from "react";
import React from "react";
import { ZoneMenu } from "./zone-menu";
import { useIsTransformMode } from "../../hooks/useIsTransformMode";
import { ZoneTransformMenu } from "../zone-transform-menu/zone-transform-menu";
import { useHasFinePointer } from "../../hooks/use-has-fine-pointer";

export const ZoneMenuContainer = memo(() => {
	const [isTransformMode] = useIsTransformMode();
	const hasFinePointer = useHasFinePointer();

	/** hasFinePointer: ATM we only show the ZoneTransformMenu when user has a mouse/stylus */
	if (hasFinePointer && isTransformMode) {
		return (
			<ZoneMenu>
				<ZoneTransformMenu />
			</ZoneMenu>
		);
	}

	return null;
});

ZoneMenuContainer.displayName = "ZoneMenuContainer";
